import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'color-picker.edit.label',
		defaultMessage: 'Change color',
		description: 'Field label. Appears when a user hovers the field.',
	},
});
